import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  constructor(public bsModalRef: BsModalRef, private modalService: BsModalService) {}

  deleteObjectWithConfirmation(objectTypeName: string, objectDescription: string, deleteCallback: () => void, deletionNotes?: string) {
    deletionNotes = deletionNotes === undefined ? '' : ` ${deletionNotes.trim()}`;
    const title = `Delete ${objectTypeName}`;
    const message = `${objectTypeName} '${objectDescription}' will be deleted.${deletionNotes} Continue?`;

    this.showConfirmationDialog(title, message, true, deleteCallback);
  }

  showConfirmationDialog(title: string, message: string, showCancel: boolean, callback: () => void) {
    this.bsModalRef = this.modalService.show(ConfirmationDialogComponent);
    if (!this.bsModalRef) {
      return;
    }

    this.bsModalRef.content.showCancel = showCancel;
    this.bsModalRef.content.title = title;
    this.bsModalRef.content.messageTop = message;

    this.bsModalRef.content.afterClosed.subscribe(result => {
      if (result) {
        callback();
      }
    });
  }
}
